import React from 'react';
import styles from "../../../styles";
import { Button } from "glamorous";

const UndoButton = ({ handleReset }) => (
  <Button
    onClick={() => { handleReset() }}
    css={styles.header.undo}
  />
);

const CloseButton = ({ handleClose }) => (
  <Button onClick={handleClose} css={styles.header.close} />
);

export { UndoButton, CloseButton };


// WEBPACK FOOTER //
// ./src/components/common/Header/Buttons.js